import { NavLink as NavLinkBase } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import type { SxProps } from "@mui/material/styles";
import styled from "@mui/material/styles/styled";

import { misc } from "app/themes/colors";
import type { Patient } from "services/types/patients.type";

type StaffTaskPatientDisplayProps = {
  patient: Partial<Patient>;
  isOpenInNewTab?: boolean;
  isComplete: boolean;
  variant?: "body1" | "body2" | "body3";
  sx?: SxProps;
};

const NavLink = styled(NavLinkBase)(() => ({
  "&": {
    color: misc.grayAsphalt
  },
  "&:hover": {
    cursor: "pointer",
    color: misc.linkColor
  },

  "&.active": {}
}));

export default function StaffTaskPatientDisplay({
  patient,
  isOpenInNewTab,
  variant = "body2",
  isComplete,
  sx
}: StaffTaskPatientDisplayProps) {
  return (
    <Box sx={{ color: isComplete ? grey[700] : undefined, ...sx }}>
      <NavLink
        to={`/patients/${patient.id}/tasks`}
        target={isOpenInNewTab ? "_blank" : undefined}
        rel={isOpenInNewTab ? "noopener noreferrer" : undefined}
      >
        <Typography variant={variant}>{patient.fullName}</Typography>
      </NavLink>
    </Box>
  );
}
